<template>
  <div class="mobile-header">
    <div class="main">
      <img :src="headerLogo" class="logo"/>
<!--      <div class="head-cover">-->
<!--        <img :src="headimgurl" v-if="headimgurl"/>-->
<!--      </div>-->
      <div class="right-icon">
        <span class="iconfont icon-daohang" @click="isNav = !isNav"></span>
      </div>
    </div>
    <div
      :class="isNav ? 'nav-div show' : 'nav-div'"
      ref="navDom"
    >
      <div
           v-for="(item, index) in menuList"
           :key="index"
           :class="item.path.indexOf(routerPath) !== -1  ? 'menu-item active' : 'menu-item'"
           @click="handleJump(item.path)"
      >
        <div
          @click="showChildren(item.children)"
          :class="isChildren ? 'item-wrap show' : 'item-wrap'"
        >
          {{ item.name }}
          <span class="iconfont icon-next" v-if="item.children.length"></span>
        </div>
        <div
          :class="isChildren ? 'item-children show' : 'item-children'"
          v-if="item.children.length"
        >
          <div
            v-for="(items, indexs) in item.children"
            :key="indexs"
            @click="handleJump(items.path)"
            :class="routerPath === items.path ? 'active' : ''"
          >
            {{ items.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="popup-div" :class="isLogin ? 'active' : ''">
      <login-popup v-if="isLogin"></login-popup>
    </div>
  </div>
</template>

<script>
import loginPopup from './loginPopup'
import Cookie from 'js-cookie'
// let headerLogo = require('../../assets/newImage/headerLogo.png')
let headerLogo = require('../../assets/newImage/header-logo.png')
export default {
  name: 'mobileHeader',
  components: {
    loginPopup
  },
  data () {
    return {
      headerLogo,
      menuList: [
        {name: '首页', path: '/home', children: []},
        {
          name: '解决方案',
          path: '/science,/AI,/spaceflight',
          children: [
            { name: '科学探索教育解决方案', path: '/science' },
            { name: '人工智能创新教育解决方案', path: '/AI' },
            { name: '航天特色教育解决方案', path: '/spaceflight' }
          ]
        },
        {name: '开源鸿蒙', path: '/openHarmony', children: []},
        {name: '创课评测', path: '/evaluating', children: []},
        {name: '课程中心', path: '/course', children: []},
        {name: '联系我们', path: '/BusinessCooperation', children: []}
        // {name: '航天大赛', path: '/competitionApply'}
        // {name: '产品介绍', path: '/product'},
        // {name: '社会责任', path: '/socialResponsibility'},
        // {name: '商务合作', path: '/BusinessCooperation'},
        // {name: '精准教学', path: ''}
      ],
      isLogin: false,
      UnionID: '',
      headimgurl: '',
      routerPath: '',
      isNav: false,
      isChildren: false
    }
  },
  watch: {
    '$route': 'getPath',
    isNav (a) {
      if (a) {
        document.body.style.overflow = 'hidden'
        this.$refs['navDom'].style.height = this.isChildren ? '385px' : '265px'
      } else {
        document.body.style.overflow = ''
        this.$refs['navDom'].style.height = '0'
      }
    },
    isLogin (a) {
      if (a) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  created () {
    this.getPath()
    this.Bus.$off('loginPopup-close')
    this.Bus.$on('loginPopup-close', () => {
      this.isLogin = false
    })
    this.Bus.$off('loginSuccessHeader')
    this.Bus.$on('loginSuccessHeader', () => {
      this.isLogin = false
      this.headimgurl = Cookie.get('headimgurl')
      this.UnionID = Cookie.get('UnionID')
    })
    this.headimgurl = Cookie.get('headimgurl')
    this.UnionID = Cookie.get('UnionID')
  },
  methods: {
    getPath () {
      this.isNav = false
      this.routerPath = this.$route.path
    },
    handleLogin () {
      this.isLogin = true
    },
    handleJump (url) {
      if (url === '/science,/AI,/spaceflight') {
        return false
      }
      if (url === '/course') {
        location.href = `https://dfck.course.kindercloud.net`
      } else {
        this.$router.push(url)
      }
    },
    showChildren (child) {
      if (child.length) {
        if (this.isChildren) {
          this.$refs['navDom'].style.height = '265px'
        } else {
          this.$refs['navDom'].style.height = '385px'
        }
        this.isChildren = !this.isChildren
      }
    }
  }
}
</script>

<style scoped lang="scss">
.mobile-header{
  position: fixed;
  z-index: 10001;
  width: 100vw;
  top: 0;
  box-sizing: border-box;
  height: 60px;
  background-color: #FFFFFF;
  .popup-div{
    position: fixed;
    top: 0;
    width: 100vw;
    left: -100vw;
    bottom: 0;
    z-index: 100;
    background-color: rgba(0,0,0,0.8);
    opacity: 0;
    transition: opacity .2s;
    display: flex;
    align-items: center;
    &.active{
      left: 0;
      opacity: 1;
    }
  }
  .main{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &>.iconfont{
      padding: 0;
      margin: 0;
      font-size: 30px;
      color: #363636;
    }
    .logo{
      height: 40px;
    }
    .right-icon{
      .iconfont{
        font-size: 28px;
      }
    }
    .head-cover{
      img{
        width: 45px;
        height: 45px;
        border-radius: 50%;
      }
      .iconfont{
        font-size: 30px;
        margin: 0;
        padding: 0;
        color: #f8f8f8;
      }
    }
  }
  .nav-div{
    width: 100vw;
    background-color: #fff;
    border-top: 1px solid #c2c2c2;
    height: 0;
    overflow: hidden;
    transition: height 0.3s;
    position: fixed;
    top: 60px;
    z-index: 10001;
    .menu-item{
      width: 100%;
      text-align: center;
      .item-wrap{
        font-size: 16px;
        line-height: 44px;
        width: 100%;
        text-align: center;
        color: #000;
        position: relative;
        .icon-next{
          position: absolute;
          right: 20px;
          transition: 0.2s;
          transform: rotate(90deg);
          font-size: 14px;
        }
      }
      .item-wrap.show{
        .icon-next{
          transform: rotate(-90deg);
        }
      }
      &.active{
        .item-wrap{
          color: #265b9f;
        }
      }
      .item-children{
        background-color: #fff;
        box-shadow: 0 0 5px #e2e2e2;
        height: 0;
        overflow: hidden;
        transition: height 0.3s;
        div{
          padding: 0 15px;
          white-space: nowrap;
          font-size: 14px;
          line-height: 40px;
          color: #666;
          &:hover{
            cursor: pointer;
            color: #265b9f;
          }
          &.active{
            color: #265b9f;
          }
        }
      }
      .item-children.show{
        height: 120px;
      }
    }
  }
  .nav-div.show{
    height: 265px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/mobileHeader.vue